<template>
  <div class="order-item" :class="activeItem.id === data.id && activeItem.type === data.type ? 'active-item' : ''" @click.stop="handleItemClick(data)">
    <div class="info">
      <div class="icon">
        <svg v-if="type !== 'item'" t="1653637391179" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="29729" width="14" height="14"><path d="M320 128h480A96 96 0 0 1 896 224V384H320V128z" fill="#E5A800" p-id="29730"></path><path d="M226.112 64h169.792c17.152 0 26.112 0.896 33.216 2.816l6.72 2.24a57.28 57.28 0 0 1 22.528 15.552l4.48 5.568c2.112 3.008 4.16 6.464 6.4 11.264l4.992 11.456L539.968 288h337.984c28.544 0 38.848 2.944 49.28 8.576 10.432 5.568 18.624 13.76 24.192 24.192 5.632 10.432 8.576 20.736 8.576 49.28v425.856c0 57.088-5.952 77.76-17.088 98.56-11.136 20.928-27.52 37.312-48.384 48.448-20.864 11.136-41.6 17.088-98.56 17.088H228.032c-57.088 0-77.76-5.952-98.56-17.088a116.288 116.288 0 0 1-48.448-48.384c-10.24-19.264-16.128-38.4-16.96-86.08L64 226.112c0-54.72 5.952-75.776 17.088-96.64 11.136-20.864 27.52-37.248 48.384-48.384C150.4 69.952 171.392 64 226.112 64z" fill="#FFCB00" p-id="29731"></path><path d="M64 731.904c0 57.088 5.952 77.76 17.088 98.56 11.136 20.928 27.52 37.312 48.384 48.448 19.264 10.24 38.4 16.128 86.08 16.96l12.544 0.128h567.808c57.088 0 77.76-5.952 98.56-17.088 20.928-11.136 37.312-27.52 48.448-48.384 10.24-19.264 16.128-38.4 16.96-86.08l0.128 51.456c0 57.088-5.952 77.76-17.088 98.56-11.136 20.928-27.52 37.312-48.384 48.448-20.864 11.136-41.6 17.088-98.56 17.088H228.032c-57.088 0-77.76-5.952-98.56-17.088a116.288 116.288 0 0 1-48.448-48.384c-11.136-20.864-17.088-41.6-17.088-98.56v-64z" fill="#000000" fill-opacity=".1" p-id="29732"></path></svg>
        <svg v-else t="1653637525578" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="29876" width="14" height="14"><path d="M215.552 64.128L795.904 64c57.088 0 77.76 5.952 98.56 17.088 20.928 11.136 37.312 27.52 48.448 48.384 11.136 20.864 17.088 41.6 17.088 98.56v567.872c0 57.088-5.952 77.76-17.088 98.56-11.136 20.928-27.52 37.312-48.384 48.448-20.864 11.136-41.6 17.088-98.56 17.088H228.032c-57.088 0-77.76-5.952-98.56-17.088a116.288 116.288 0 0 1-48.448-48.384c-10.24-19.264-16.128-38.4-16.96-86.08L64 228.096c0-57.088 5.952-77.76 17.088-98.56 11.136-20.928 27.52-37.312 48.384-48.448 19.264-10.24 38.4-16.128 86.08-16.96z" fill="#56CE75" p-id="29877"></path><path d="M64 731.904c0 57.088 5.952 77.76 17.088 98.56 11.136 20.928 27.52 37.312 48.384 48.448 19.264 10.24 38.4 16.128 86.08 16.96l12.544 0.128h567.808c57.088 0 77.76-5.952 98.56-17.088 20.928-11.136 37.312-27.52 48.448-48.384 10.24-19.264 16.128-38.4 16.96-86.08l0.128 51.456c0 57.088-5.952 77.76-17.088 98.56-11.136 20.928-27.52 37.312-48.384 48.448-20.864 11.136-41.6 17.088-98.56 17.088H228.032c-57.088 0-77.76-5.952-98.56-17.088a116.288 116.288 0 0 1-48.448-48.384c-11.136-20.864-17.088-41.6-17.088-98.56v-64z" fill="#000000" fill-opacity=".1" p-id="29878"></path><path d="M464 224a16 16 0 0 1 16 16v48a16 16 0 0 1-16 16H375.936l0.064 160a16 16 0 0 1-16 16h-48a16 16 0 0 1-16-16l-0.064-160H208A16 16 0 0 1 192 288v-48a16 16 0 0 1 16-16h256z" fill="#FFFFFF" p-id="29879"></path><path d="M816 400a16 16 0 0 1 16 16v48a16 16 0 0 1-16 16h-224A16 16 0 0 1 576 464V416a16 16 0 0 1 16-16h224z m0-176a16 16 0 0 1 16 16v48a16 16 0 0 1-16 16h-224A16 16 0 0 1 576 288v-48a16 16 0 0 1 16-16h224z" fill="#FFFFFF" fill-opacity=".7" p-id="29880"></path><path d="M816 736a16 16 0 0 1 16 16v48a16 16 0 0 1-16 16h-608A16 16 0 0 1 192 800v-48a16 16 0 0 1 16-16h608z m0-160a16 16 0 0 1 16 16V640a16 16 0 0 1-16 16h-608A16 16 0 0 1 192 640v-48A16 16 0 0 1 208 576h608z" fill="#FFFFFF" fill-opacity=".4" p-id="29881"></path></svg>
      </div>
      <div class="text-info">
        <p class="title">{{ data.nameTitle }}</p>
        <p class="des">{{ data.statusText }}</p>
      </div>
      <div class="sub-switch" v-if="Array.isArray(data.children) && data.children.length" @click.stop="showChildren = !showChildren">
        <svg v-if="!showChildren" t="1653632759258" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="29439" width="100%" height="100%"><path d="M737.984 445.696l-45.248-45.248-180.992 181.056-181.056-181.056-45.248 45.248L511.744 672z" fill="#2C374D" p-id="29440"></path></svg>
        <svg v-else t="1653634935824" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="29584" width="100%" height="100%"><path d="M737.984 578.304l-45.248 45.248-180.992-181.056-181.056 181.056-45.248-45.248L511.744 352z" fill="#2C374D" p-id="29585"></path></svg>
      </div>
    </div>
    <div class="sub-item-container" v-if="Array.isArray(data.children) && data.children.length">
      <template v-if="showChildren">
        <template  v-for="(item, index) in data.children">
          <SubItem :activeItem="activeItem" :data="item" :key="index" @subItemClick="handleItemClick"/>
        </template>
      </template>
    </div>
  </div>
</template>
<script>
import SubItem from './SubItem.vue'
export default {
  name: 'OrderItem',
  components: { SubItem },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    },
    type: {
      type: String,
      default: 'item'
    },
    activeItem: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      showChildren: false
    }
  },
  methods: {
    handleItemClick(data = this.data) {
      this.$emit('itemClick', data)
    }
  }
}
</script>
<style lang="less" scoped>
  .order-item{
    box-sizing: border-box;
    background: #FFF;
    border-radius: 6px;
    .info{
      display: flex;
      .icon{
        margin-left: 16px;
        margin-top: 15px;
      }
      .text-info{
        flex-grow: 1;
        min-width: 10px;
        margin-left: 9px;
        margin-top: 14px;
        .title{
          height: 22px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2A2F3D;
          line-height: 22px;
        }
        .des{
          margin-bottom: 15px;
          height: 18px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #787E8F;
          line-height: 18px;
        }
      }
      .sub-switch{
        width: 20px;
        height: 20px;
        margin-top: 15px;
        margin-right: 16px;
      }
    }
    .sub-item-container{
      border-top: 1px solid #f1f1f1;
    }
    & + .order-item{
      margin-top: 12px;
    }
    &:hover{
      cursor: pointer;
    }
  }
  .active-item{
    border: 2px solid rgba(51, 126, 255, 0.64);
    box-sizing: border-box;
  }
</style>